import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { loginMember } from "../../actions/authActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from "../../validation/is-empty";
import './login.css';

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      password: "",
      error: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      this.setState({ error: this.props.errors });
    }
  };

  onClick(e) {
    e.preventDefault();
    const { phone, password } = this.state;

    let error = {};
    if (isEmpty(phone)) {
      error.phone= "請輸入手機號碼";
    } else {
      const re = new RegExp(/^[0-9]/);
      if (!re.test(phone)) {
        error.phone= "手機號碼只能輸入數字";
      }
    }

    if (isEmpty(password)) {
      error.password= "請輸入密碼";
    } else {
      if (password.length < 8) {
        error.password= "密碼最短長度為 8 碼";
      }
    }

    if (!isEmpty(error)){
      this.setState({ error: error });
    } else {
      this.setState({ error: {} });
      this.props.loginMember({phone: phone, password: password});
    }
  };

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { error, phone, password } = this.state;
    
    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(!isAuthTokenValid) && (
        <div id="page">
          <Navbar />
          <div className="colorlib">
            <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                    <h1 style={{color: "#fff", fontWeight: "700", textAlign: "center", margin: "30px 0px 60px"}}>歡迎！登入儲值中心</h1>
                    <div className="form-container">
                      <form id="logInForm" data-toggle="validator" data-focus="false">

                        <div className="form-group">
                          <input id="phone" name="phone" className="form-control" style={{margin: "0 auto"}} type="text" placeholder="請輸入手機號碼" value={phone} onChange={this.onChange} />
                          {error.phone && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.phone}</span> )} 
                        </div>

                        <div className="form-group">
                          <input id="password" name="password" className="form-control" style={{margin: "0 auto"}} type="password" placeholder="請輸入密碼" value={password} onChange={this.onChange} />
                          {error.password && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.password}</span> )} 
                        </div>    

                        <div className="form-group">
                          <button type="button" className="btn btn-danger btn-block" style={{margin: "0 auto"}} onClick={this.onClick} >
                          <a href="" style={{color: "#fff", textDecoration: "none", fontSize: "1.5rem"}}> 登入 </a>
                          </button>
                        </div>

                        <div className="form-group">
                          <button type="button" className="btn btn-primary btn-block" style={{margin: "0 auto"}}>
                          <a href="/members/signup" style={{color: "#fff", textDecoration: "none", fontSize: "1.5rem"}}>註冊新帳號</a>
                          </button>
                        </div>

                      </form>
                      <h5 style={{textAlign: "center"}}><a href="/members/forget_pwd">忘記密碼</a></h5>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <Footer showAgreement={true} />
        </div>
        )}
      </Fragment>
    );
  }
}

LoginPage.propTypes = {
  loginMember: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  errors: state.errors,
  member: state.auth.member
});

export default connect(mapStateToProps, { loginMember })(LoginPage);